export const paletteTheme = {
  colorWhite: "#ffffff",
  colorPrimary: "#41B38C",
  colorPrimaryLight16: "rgba(65, 179, 140, 0.16)",
  colorPrimaryActive: "#90CCB7",
  colorPrimaryHover: "#90CCB7",
  colorPrimaryBackground: "rgba(65, 179, 140, 0.08)",
  colorText: "#1B242B",
  colorError: "#D75337",
  colorError8: "rgba(215, 83, 55, 0.08)",
  colorErrorText: "#D75337",
  colorIcon: "#838688",
  colorIcon32: "#838688",
  colorFillSecondary: "#F3F5F6",
  colorBorderSecondary: "#D9DBDC",
  colorWarning: "#CB8B1F",
  colorWarning8: "#CB8B1F14",
  colorLightWarning: "#EBBE67",
  colorBackgroundWarning: "rgba(235, 190, 103, 0.16)",
  colorBlue: "#427FF4",
  colorBackgroundBlue: "rgba(66, 127, 244, 0.16)",
  gold: "#EBBE67",
  gold8: "rgba(235, 190, 103, 0.08)",
  grey: "#838688",
  greyBg: "#D9DBDC",
  colorInfo: "#427FF4",
  colorInfoBg: "rgba(66, 127, 244, 0.08)",
  midGrey: "#B6B8B9",
  colorSuccess: "#41B38C",
};
